const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl, ToggleControl, RangeControl } = wp.components;
import CommonPanel from '../../wp-controlers/common-panel';
import ImageControl from '../../wp-controlers/mediaUpload';

const Inspector = ({ attributes, setAttributes }) => {
  const {
    imagePosition,
    hideDesktop,
    hideMobile,
    absolute,
    positionAbsolute,
    positionAbsoluteVertical,
    borderRadius,
  } = attributes;

  return (
    <InspectorControls>
      <PanelBody>
        <p>Selecione a imagem desejada</p>
        <ImageControl
          image="image"
          attributes={attributes}
          setAttributes={setAttributes}
        />

        <RangeControl
          label="Borda da imagem"
          initialPosition={borderRadius}
          value={borderRadius}
          onChange={(value) => setAttributes({ borderRadius: value })}
          min={0}
          max={200}
        />

        {!absolute && (
          <SelectControl
            label="Selecione a posição da imagem dentro do container"
            title="Selecione a posição da imagem dentro do container"
            value={imagePosition}
            options={[
              { label: 'Esquerda', value: 'image-left' },
              { label: 'Centro', value: 'image-center' },
              { label: 'Direita', value: 'image-right' },
              { label: 'Esquerda - Centro', value: 'image-left-center' },
              { label: 'Centro - Esquerda', value: 'image-center-left' },
            ]}
            onChange={(position) => setAttributes({ imagePosition: position })}
          />
        )}

        <ToggleControl
          label="Ocultar a imagem em desktop ?"
          checked={hideDesktop}
          onChange={() => setAttributes({ hideDesktop: !hideDesktop })}
        />

        <ToggleControl
          label="Ocultar a imagem em mobile ?"
          checked={hideMobile}
          onChange={() => setAttributes({ hideMobile: !hideMobile })}
        />

        <ToggleControl
          label="Adicionar posição absoluta ?"
          checked={absolute}
          onChange={() => setAttributes({ absolute: !absolute })}
        />

        {absolute && (
          <>
            <SelectControl
              label="Selecione a posição horizontal da imagem dentro do container"
              title="Selecione a posição horizontal da imagem dentro do container"
              value={positionAbsolute}
              options={[
                { label: 'Esquerda', value: 'absolute-left' },
                { label: 'Direita', value: 'absolute-right' },
              ]}
              onChange={(position) =>
                setAttributes({ positionAbsolute: position })
              }
            />

            <SelectControl
              label="Selecione a posição vertical da imagem dentro do container"
              title="Selecione a posição vertical da imagem dentro do container"
              value={positionAbsoluteVertical}
              options={[
                { label: 'Topo', value: 'absolute-top' },
                { label: 'Centro', value: 'absolute-center' },
                { label: 'Baixo', value: 'absolute-bottom' },
              ]}
              onChange={(position) =>
                setAttributes({ positionAbsoluteVertical: position })
              }
            />
          </>
        )}
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
